<template>
    <div class="page-builder" style="position: relative" @onmouseup="resizeStop" >
        <div class="block" v-for="(block, index) in blocks" :key="block.id" background="block.color">
                <TextBlock v-if="block.type == 'text'" :block="block" @copy_main_block="copyblock(index)" @move_row_up="move_row_up_m(index)" @move_row_down="move_row_down_m(index)" @block-delete="() => {blocks.splice(index, 1)}"></TextBlock>
                <links-block v-if="block.type == 'links'" :block="block" @copy_main_block="copyblock(index)" @move_row_up="move_row_up_m(index)" @move_row_down="move_row_down_m(index)"  @block-delete="() => {blocks.splice(index, 1)}"></links-block>
                <youtube-block v-if="block.type == 'youtube'" :block="block" @copy_main_block="copyblock(index)" @move_row_up="move_row_up_m(index)" @move_row_down="move_row_down_m(index)"  @block-delete="() => {blocks.splice(index, 1)}"></youtube-block>
                <list-block v-if="block.type == 'list'" :block="block" @copy_main_block="copyblock(index)" @move_row_up="move_row_up_m(index)" @move_row_down="move_row_down_m(index)"  @block-delete="() => {blocks.splice(index, 1)}"></list-block>
                <items-block v-if="block.type == 'items'" :block="block" @copy_main_block="copyblock(index)"  @move_row_up="move_row_up_m(index)" @move_row_down="move_row_down_m(index)" @block-delete="() => {blocks.splice(index, 1)}"></items-block>
                <html-block v-if="block.type == 'html'" :block="block" @copy_main_block="copyblock(index)"  @move_row_up="move_row_up_m(index)" @move_row_down="move_row_down_m(index)" @block-delete="() => {blocks.splice(index, 1)}"></html-block>
        </div>
        <div class="fab-container">

            <v-btn
                    color="green"
                    dark
                    small
                    fab
                    @click="drawer = true"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>


            <v-bottom-sheet v-model="addSheet" inset>
            <v-sheet class="text-center sheet" height="200px">
                <v-container>
                    <v-row>
                        <v-col cols="3">
                            <div class="select-block" @click="addBlock('text')">
                                <v-icon size="50px">mdi-text</v-icon>
                                <span>Текст</span>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="select-block" @click="addBlock('links')">
                                <v-icon size="50px">mdi-link</v-icon>
                                <span>Ссылки</span>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="select-block" @click="addBlock('youtube')">
                                <v-icon size="50px">mdi-youtube</v-icon>
                                <span>YouTube<br>видео</span>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div class="select-block" @click="addBlock('list')">
                                <v-icon size="50px">mdi-format-list-numbered</v-icon>
                                <span>Пункты</span>
                            </div>
                        </v-col>
                      <v-col cols="3">
                        <div class="select-block" @click="addBlock('html')">
                          <v-icon size="50px">mdi-code-braces</v-icon>
                          <span>HTML</span>
                        </div>
                      </v-col>
                    </v-row>
                </v-container>
            </v-sheet>
        </v-bottom-sheet>

        </div>


        <v-navigation-drawer
                v-model="drawer"
                fixed
                temporary
                app
        >
            <v-list dense>

                <v-list-item
                        link
                        @click="addBlock('text'), drawer = false"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-text</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Текст</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                        link
                        @click="addBlock('links'), drawer = false"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-link</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Ссылки</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                        link
                        @click="addBlock('items'), drawer = false"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-hexagon-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Смешанный</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                        link
                        @click="addBlock('list'), drawer = false"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-format-list-numbered</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>Пункты</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                        link
                        @click="addBlock('youtube'), drawer = false"
                >
                    <v-list-item-icon>
                        <v-icon>mdi-youtube</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>YouTube видео</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

              <v-list-item
                  link
                  @click="addBlock('html'), drawer = false"
              >
                <v-list-item-icon>
                  <v-icon>mdi-code-braces</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>HTML</v-list-item-title>
                </v-list-item-content>
              </v-list-item>


            </v-list>
        </v-navigation-drawer>

    </div>
</template>

<script>
    import TextBlock from "./TextBlock";
    import LinksBlock from "./LinksBlock";
    import YoutubeBlock from "./YoutubeBlock";
    import ListBlock from "./ListBlock";
    import ItemsBlock from "./ItemsBlock";
    import HtmlBlock from "./HtmlBlock";

    export default {
        name: "ThePageBuilder",
        props: ["protoblocks"],
        components:{
            TextBlock,
            LinksBlock,
            YoutubeBlock,
            ListBlock,
            ItemsBlock,
            HtmlBlock
        },
        data(){
            return{
                drawer: false,
                items: [

                ],
                addSheet: false,
                blocks: [

                ]
            }
        },
        computed: {
            maxId(){
                if(this.blocks.length == 0){
                    return 0;
                } else {
                    return Math.max(...this.blocks.map(kek => kek.id))
                }
            }
        },
        watch:{
            blocks:{
                deep: true,
                handler(){
                    this.$emit("update-blocks", this.blocks)
                }
            }
        },
        methods:{
            copyblock(index){
                let copy = Object.assign({},  this.blocks[index])
                copy.id=this.maxId + 1;
                this.blocks.push(copy);

            },
           move_row_up_m(index){
               if(index === 0){return}
               let rows = [ this.blocks[index-1],  this.blocks[index]];
               this.blocks.splice(index-1, 2, rows[1], rows[0] );
           },
            move_row_down_m(index){
                if(index === this.blocks.length-1){return}
                let rows = [ this.blocks[index],  this.blocks[index+1]];
                this.blocks.splice(index, 2, rows[1], rows[0] );
            },
            resizeStop(){
                document.onmousemove = null
            },
            addBlock(type){
                var block
                switch(type){
                    case "items":
                        block = {
                            id: this.maxId + 1,
                            type: "items",
                            items: [
                                {
                                    id: 1,
                                    type: "text",
                                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                    align: "center"
                                },
                                {
                                    id: 2,
                                    type: "link",
                                    link: {
                                        "icon":"https://thumb.tildacdn.com/tild3930-3731-4466-b739-323364393133/-/resize/100x/-/format/webp/34.png",
                                        "name":"ВКонтакте",
                                        "url":"http://vk.com"
                                    }
                                },
                                {
                                    id: 3,
                                    type: "text",
                                    content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
                                    align: "center"
                                },
                            ],
                            cols: 4,
                            color: "#00000000",
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                        break
                    case 'text':
                        block = {
                            id: this.maxId + 1,
                            type: "text",
                            component: "text-block",
                            content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
                            align: "left",
                            color: "#00000000",
                            fontSize: 16,
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                        break
                    case "links":
                        block = {
                            id: this.maxId + 1,
                            type: "links",
                            component: "links-block",
                            links: [
                                {
                                    id: 1,
                                    "icon":"https://thumb.tildacdn.com/tild3930-3731-4466-b739-323364393133/-/resize/100x/-/format/webp/34.png",
                                    "name":"asdasdasdasd asdasdasdasd ",
                                    "url":"asdadasdasdasdasdadadasdasdasd"
                                },
                                {
                                    id: 2,
                                    "icon":"https://thumb.tildacdn.com/tild3930-3731-4466-b739-323364393133/-/resize/100x/-/format/webp/34.png",
                                    "name":"adasdasdasdasdasdas",
                                    "url":"dadasdasadadasdasd"
                                },
                                {
                                    id: 3,
                                    "icon":"https://thumb.tildacdn.com/tild3930-3731-4466-b739-323364393133/-/resize/100x/-/format/webp/34.png",
                                    "name":"222222222222222 222222222",
                                    "url":"awasdsdadasdad"
                                }
                            ],
                            cols: 3,
                            color: "#00000000",
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                        break
                    case "youtube":
                        block = {
                            id: this.maxId + 1,
                            type: "youtube",
                            component: "youtube-block",
                            url: "",
                            color: "#00000000",
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                        break
                    case "list":
                        block = {
                            id: this.maxId + 1,
                            type: "list",
                            points: [
                                {
                                    id: 1,
                                    title: "Hight Quality",
                                    description: "We are the leading firm by delivering quality and value to our clients. All our professionals have more than 5 years of legal experiences. We like what we do."
                                },
                                {
                                    id: 2,
                                    title: "Hight Quality",
                                    description: "We are the leading firm by delivering quality and value to our clients. All our professionals have more than 5 years of legal experiences. We like what we do."
                                },
                                {
                                    id: 3,
                                    title: "Hight Quality",
                                    description: "We are the leading firm by delivering quality and value to our clients. All our professionals have more than 5 years of legal experiences. We like what we do."
                                },

                            ],
                            color: "#00000000",
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                        break
                    case "html":
                      block = {
                        id: this.maxId + 1,
                        type: "html",
                        component: "html-block",
                        content: "<div style='display: none;'>test html block</div>",
                        align: "left",
                        color: "#00000000",
                        fontSize: 16,
                        paddingTop: 0,
                        paddingBottom: 0
                      }
                }
                this.blocks.push(block)
                this.addSheet = false

            }
        },
        mounted() {
            this.blocks = this.protoblocks
        }
    }
</script>

<style scoped>
    .page-builder{

        text-align: left;
        width: 100%;
    }

    .sheet{
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .fab-container{
        position: absolute;
        bottom: -20px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

    .select-block{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        cursor: pointer;
    }

    .block{

    }
</style>
